import { useEffect, useRef, useState } from "react";

export interface LogLine { ts: number; text: string; }
export interface UseLiveLogReturn {
  lines: LogLine[];
  state: string;
  exitCode: number | null;
  done: boolean;
}

export function useLiveLog(jobId: string | null): UseLiveLogReturn {
  const [lines, setLines] = useState<LogLine[]>([]);
  const [state, setState] = useState("unknown");
  const [exitCode, setExit] = useState<number | null>(null);
  const [done, setDone] = useState(false);
  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    if (!jobId) return;
    setLines([]); setState("unknown"); setExit(null); setDone(false);
    const es = new EventSource(`/api/jobs/${jobId}/log/stream`);
    esRef.current = es;
    es.addEventListener("line", (e: MessageEvent) => {
      try {
        const d = JSON.parse(e.data);
        setLines(prev => [...prev, { ts: Date.now(), text: d.text }]);
      } catch {}
    });
    es.addEventListener("state", (e: MessageEvent) => {
      try { setState(JSON.parse(e.data).state); } catch {}
    });
    es.addEventListener("done", (e: MessageEvent) => {
      try {
        const d = JSON.parse(e.data);
        setState(d.state); setExit(d.exit_code ?? null); setDone(true);
      } catch {}
      es.close();
    });
    es.onerror = () => { setDone(true); es.close(); };
    return () => es.close();
  }, [jobId]);

  return { lines, state, exitCode, done };
}
